import React from 'react'
import produce, { current } from 'immer';
import { useSelector, useDispatch } from 'react-redux';

import ReactTooltip from 'react-tooltip';
import { QuestionCircleFilled } from '@ant-design/icons'

import { RootState } from '../../modules';
import { editContent } from "../../modules/editor";

import { SUPPORT_TYPE } from '../../constants'
import check from '../../assets/images/icon/check.png';
import checked from '../../assets/images/icon/checked.png';
import FieldSection from './FieldSection';
import Select from '../../components/Dropdown/Select';
import HelpWord from '../../components/Forms/HelpWord';

type Props = {
  currentContent: any
}

const options = [
  { name: '이메일, 웹 공개', value: "ALL" },
  { name: '이메일에서만 공개', value: "EMAIL" },
  { name: '웹에서만 공개', value: "WEB" },
]

export default function SelectedSupportType({currentContent = {}}: Props) {
	const dispatch = useDispatch();
  const { supportType = SUPPORT_TYPE.ALL } = currentContent;
  const selectedContentId = useSelector((state: RootState) => state.editor.selectedContentId);
  const contents = useSelector((state: RootState) => state.editor.contents);

  const targetIndex = contents?.findIndex((item) => {
    return item.id === selectedContentId;
  }); 

	const onWebToggle = (supportType) => {
		dispatch(editContent({ target: `${currentContent?.id}/supportType`, data: supportType}));
	}

  return (
    <>
      <div style={{display: 'flex', alignItems: 'center', marginTop: 12}}>
        <h3 className="field-section-title" style={{paddingRight: 4, paddingBottom: 15}} >상자 표시 설정</h3>
        <HelpWord word={`<div>이메일, 웹(공유용 URL, 아카이브, <br />페이지)을 구분해 상자를 표시할 수<br /> 있습니다. <a href="https://help.stibee.com/email/edit/using-edit-box#box-display-settings" target="_blank">자세히보기</a></div>`} 
        place="top" />
      </div>


      {/* <div className="info-tooltip">
					<button>
						<i className="stb-info_3"></i>
					</button>
					<div className="txt">
            내용
					</div>
				</div> */}

      <FieldSection
					label={false}
					layout="vertical"
					labelSize="small"
				>
					<Select
						target={`${currentContent?.id}/supportType`}
						value={currentContent?.content?.supportType}
						options={options}
					/>
				</FieldSection>

      {/* <div>
      <button 
        onClick={(()=>onWebToggle(SUPPORT_TYPE.WEB))} className="toggle"
      >
          {currentContent?.content?.supportType == SUPPORT_TYPE.WEB? (
            <img src={checked} alt="check" width="22" />
          ) : (
            <img src={check} alt="check" width="22" />
          )}
        WEB Browser 에서 보임
      </button>
    </div>
    <div>
      <button 
        onClick={(()=>onWebToggle(SUPPORT_TYPE.EMAIL))} className="toggle"
      >
          {currentContent?.content?.supportType == SUPPORT_TYPE.EMAIL? (
            <img src={checked} alt="check" width="22" />
          ) : (
            <img src={check} alt="check" width="22" />
          )}
        EMAIL 에서 보임
      </button>
    </div>
    <div>
      <button 
        onClick={(()=>onWebToggle(SUPPORT_TYPE.ALL))} className="toggle"
      >
          {currentContent?.content?.supportType == SUPPORT_TYPE.ALL? (
            <img src={checked} alt="check" width="22" />
          ) : (
            <img src={check} alt="check" width="22" />
          )}
        둘다에서 보임
      </button>
    </div> */}
    </>
  )
}